/**
 * Date affichée à l'administrateur, toujours à l'heure de Paris.
 *
 * SQLite écrit ses dates en UTC sans fuseau (« 2026-10-14 06:43:38 ») : `new Date()` lit ce format comme une heure
 * LOCALE du navigateur, ce qui décalait l'affichage (de 2 h en octobre pour un navigateur à Paris, davantage ailleurs).
 * On la lit donc explicitement comme de l'UTC ; une date ISO (« …T06:43:38.000Z ») est déjà non ambiguë.
 */
const SQLITE_UTC = /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}(?::\d{2})?)$/;

export function parseServerDate(value: string): Date {
    const match = SQLITE_UTC.exec(value.trim());
    return new Date(match ? `${match[1]}T${match[2]}Z` : value);
}

export function formatParisDate(value: string): string {
    const date = parseServerDate(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString('fr-FR', {
        timeZone: 'Europe/Paris',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}
